import React from 'react';
import CustomAutocomplete from '../../../components/CustomAutocomplete';
import { instanceRef } from '../../../utils/axios';

const PAGE_SIZE = 10;
export default function AseguradoraSelect({ handleChange }) {
  const mapOptions = ({ id: value, descripcion: label }) => ({
    value,
    label
  });

  const fetchListAseguradora = (searchText) => {
    return instanceRef.instance.get(`/aseguradoras`, {
      params: {
        current: 1,
        pageSize: PAGE_SIZE,
        filters: {
          descripcion: searchText,
          all: true
        }
      }
    });
  };

  return (
    <>
      <CustomAutocomplete
        placeholder="Buscar aseguradora"
        fetchOptions={fetchListAseguradora}
        mapOptions={mapOptions}
        onChange={handleChange}
        listHeight={32 * PAGE_SIZE}
      />
    </>
  );
}
